import { BaseModel } from './BaseModel';
import { Batch } from './Batch';
import { Silo } from './Silo';

export class Shed extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.id = data.id ?? null;
    this.name = data.name ?? null;

    this.propertyName = isApi ? data.property_name : data.propertyName ?? null;

    this.propertyOwner = isApi ? data.property_owner : data.propertyOwner ?? null;

    this.core = data.core ?? null;
    this.identification = data.identification ?? null;
    this.description = data.description ?? null;
    this.property = data.property ?? null;

    // Último lote
    const lastBatchData = isApi ? data.last_batch : data.lastBatch;

    this.lastBatch = lastBatchData ? Batch.create(lastBatchData, source) : null;

    // Lotes
    const batchesData = isApi ? data.batches : data.batches;

    this.batches = Array.isArray(batchesData)
      ? batchesData.map((b) => Batch.create(b, source))
      : [];

    // Nutrição
    const silosData = isApi ? data.silos : data.silos;

    this.silos = Array.isArray(silosData) ? silosData.map((s) => Silo.create(s, source)) : [];

    // Abate
    this.targetWeight = isApi ? data.target_value : data.targetWeight ?? null;

    this.shedStates = isApi ? data.shed_states || [] : data.shedStates || [];
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }

  updateSilosData(silos, source = 'api') {
    if (Array.isArray(silos)) {
      this.silos = silos.map((s) => Silo.create(s, source));
    }
  }
}
